import type { IncidentsResponse } from 'apis/incidents/incidents_response_type';

type Props = Required<{
  incidents: IncidentsResponse[];
}>;

export const IncidentsArea = ({ incidents }: Props) => {
  return (
    <>
      {incidents.length > 0 && (
        <div className="incidents-container">
          <div className="incidents-text">
            {incidents.map((incident: IncidentsResponse) => (
              <p
                className="white-space-pre-wrap"
                key={`${incident.id}-${incident.message}`}
              >
                {incident.message}
              </p>
            ))}
          </div>
        </div>
      )}
      <style>
        {/* FIXME: refine */}
        {`
          .white-space-pre-wrap {
            white-space: pre-wrap;
          }
          .incidents-container {
            padding-top: 60px;
          }
          .incidents-text {
            text-align: center;
            color: #fff;
            height: auto;
            width: 100%;
            vertical-align: middle;
            background-color: #eb9348 !important;
            padding-top: 25px;;
            padding-bottom: 25px;
            line-height: 1.2;
          }
        `}
      </style>
    </>
  );
};
